// Reset password pages — shopify sends a URL to the user with a complicated path
import { useRouter } from 'next/router'

import { gtmEvent } from '@lib/analytics/gtm'
import fetcher from '@lib/fetcher'
import customerActivateMutation from '@lib/mutations/customer-activate'

import ResetPassword from '@components/profile/SignIn/ResetPassword'

interface IFormInput {
	password: string
	signInError: string
	passwordConfirm: string
	errorOther?: string
}

export default function ResetPasswordScreen() {
	const router = useRouter()
	// Submit reset password
	const onSubmit = async (data: IFormInput) => {
		const activationUrl = router.query.activation_url as string
		const redirectPath = router.query.redirect as string
		const customerId = activationUrl.replace(/.*activate\/+(.*?)\/.*/, '$1')

		const { customerActivateByUrl } = await fetcher({
			query: customerActivateMutation,
			variables: {
				activationUrl,
				password: data.password
			}
		})

		// GTM: track invalid activation url.
		if (customerActivateByUrl?.customerUserErrors?.length > 0)
			gtmEvent({
				event: 'AccountActivationInvalidURL',
				data: {
					activationUrl,
					customerId,
					password: data.password
				}
			})

		// if url has redirect query
		if (redirectPath) router.push(redirectPath)

		return customerActivateByUrl as { customerUserErrors: any[] }
	}

	return <ResetPassword onSubmit={onSubmit} />
}
